<template>
  <div class="employees">
    <span
      class="employee-picture"
      v-for="employee in shownKeepersEmployees"
      :key="employee.id"
    >
      <img
        v-if="employee.employee_picture && employee.employee_picture != ''"
        :class="[
          'm-l-5 max-w-40 img-circle',
          { 'primary-employee': employee.id === data.employee_default_id },
        ]"
        :src="employee.employee_picture"
        :alt="getInitials(employee.name)"
        width="30"
        height="30"
        :title="employee.name"
      />
      <span v-else>
        <span
          :class="[
            'm-l-5 max-w-40 img-circle w-30 h-30',
            { 'primary-employee': employee.id === data.employee_default_id },
          ]"
          :title="employee.name"
        >
          {{ getInitials(employee.name) }}
        </span>
      </span>
    </span>
    <span style="position: absolute; opacity: 0">
      {{ keepersNames.toString() }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    shownKeepersEmployees() {
      if (this.data && this.data.keepers_employees) {
        return this.data.keepers_employees.filter((employee) => {
          return ![1, 5, 7, 135].includes(employee.id);
        });
      }

      return [];
    },
    keepersNames() {
      return this.shownKeepersEmployees.length > 0 ? this.shownKeepersEmployees.map((employee) => {
        return employee.email;
      }) : 'N/A';
    },
  },
  methods: {
    getInitials(name) {
      name = name.replaceAll(" | Keepers", "").split(" ");
      let initials = "";

      name.forEach((word) => {
        initials += word.charAt(0).toUpperCase();
      });

      return initials;
    },
  },
};
</script>

<style scoped lang="scss">
span {
  cursor: default;
}

.employees {
  box-sizing: content-box;

  .employee-picture {
    position: relative;
  }
}

span.img-circle {
  background-color: #003e52;
  color: white;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

.v-datatable-root img.primary-employee {
  border-style: solid;
}
</style>